import { Box, BoxProps } from "@mui/material";
import React from "react";

export const TaskDynamicFormContainer = (props: BoxProps) => (
    <Box display="flex" flexWrap="wrap" marginLeft="-15px" marginRight="-15px">
        {props.children}
    </Box>
);
